import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-2"
}
const _hoisted_2 = { class: "whitespace-pre-line" }
const _hoisted_3 = { class: "text-xl font-bold pt-4" }
const _hoisted_4 = { class: "whitespace-pre-line" }
const _hoisted_5 = {
  key: 0,
  class: "text-xl font-bold pt-4"
}
const _hoisted_6 = { class: "whitespace-pre-line" }
const _hoisted_7 = {
  key: 1,
  class: "text-xl font-bold pt-4"
}
const _hoisted_8 = { class: "whitespace-pre-line" }

import AccordionComponent from "@/components/accordion/AccordionComponent.vue";
import { inject, ref, watch } from "vue";
import { DestinyMatrix, DestinyMatrixKeysEnum } from "@/types/destinyMatrix";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'PrevLifesTasksAccordion',
  props: /*@__PURE__*/_mergeModels({
    matrix: {},
    hasPremiumAccess: { type: Boolean }
  }, {
    "modelValue": { type: Boolean, ...{ default: false } },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;
const isOpen = _useModel<boolean>(__props, "modelValue");
const getDescription =
  inject<(key: DestinyMatrixKeysEnum) => Promise<never>>("getDescription");

const { t } = useI18n();

watch(
  () => props.matrix,
  () => (description.value = undefined)
);

const description = ref();

async function getData() {
  if (!props.hasPremiumAccess) {
    isOpen.value = false;
  }
  if (!description.value && props.matrix && getDescription) {
    description.value = await getDescription(
      DestinyMatrixKeysEnum.PREVIOUS_LIVES_TASKS
    );
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AccordionComponent, {
    type: "white",
    onOpened: getData,
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
    isBlocked: !__props.hasPremiumAccess
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)("calculators.destiny-matrix.accordions.previous-lives-tasks.title")), 1)
    ]),
    "faq-content": _withCtx(() => [
      (description.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)("calculators.destiny-matrix.accordions.previous-lives-tasks.desc")), 1),
            _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)(
              "calculators.destiny-matrix.accordions.previous-lives-tasks.main-soul-task-title",
              { value: __props.matrix.r1.b }
            )), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(description.value[__props.matrix.r1.b]), 1),
            (__props.matrix.r1.b !== __props.matrix.r3.b)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(t)(
              "calculators.destiny-matrix.accordions.previous-lives-tasks.communicate-soul-exp-title",
              { value: __props.matrix.r3.b }
            )), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, _toDisplayString(description.value[__props.matrix.r3.b]), 1),
            (__props.matrix.r1.b !== __props.matrix.r2.b && __props.matrix.r3.b !== __props.matrix.r2.b)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(t)(
              "calculators.destiny-matrix.accordions.previous-lives-tasks.prev-life-lesson-title",
              { value: __props.matrix.r2.b }
            )), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, _toDisplayString(description.value[__props.matrix.r2.b]), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    "collapse-text-btn": _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)("calculators.destiny-matrix.accordions.collapse")), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "isBlocked"]))
}
}

})